export default __webpack_public_path__ + "static/media/Username_Active.936afc42.svg";